import { render, staticRenderFns } from "./WaitingTime.vue?vue&type=template&id=e5ff1bbc"
import script from "./WaitingTime.vue?vue&type=script&lang=js"
export * from "./WaitingTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports